export default __webpack_public_path__ + "static/media/404.e1501f66.png";